import DesignOptionControls from "./DesignOptionControls";
import useDesignOptionActions from "./useDesignOptionActions";

const DesignOptionSwitcher = () => {
  const actions = useDesignOptionActions();

  if (!actions.visible) {
    return null;
  }

  return <DesignOptionControls {...actions} />;
};

export default DesignOptionSwitcher;
